import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, TextField, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import { HowToRegTwoTone } from '@material-ui/icons';
import moment from 'moment';
import Toggle from './Toggle';
import FilterBox from './FilterBox';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';

export default class Nominations extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            querying: true,
            nominations_array: [],
            nominate_view: false,
            search_name: '',
            search_number: '',
            search_ready: false,
            searching: false,
            current_record: {},
            nominees_array: [],
            show_nominees: false,
            creating_nomination: false,
        }

        this.state = {
            error: false,
            error_message: '',
            querying: true,
            nominations_array: [],
            nominate_view: false,
            search_name: '',
            search_number: '',
            search_ready: false,
            searching: false,
            current_record: {},
            nominees_array: [],
            show_nominees: false,
            creating_nomination: false,
            filtered_nominations_array: [],
            filter_applied: false,
            filter_obj: {},
        };

        this.datasheetFieldSpecs = [
            { field: 'nominate', headerName: 'Nominate', width: 95, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.openSearch(parms)} 
                >
                    <HowToRegTwoTone/>
                </IconButton>
            )},
            { field: 'assessee_name', headerName: 'Assessee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 160},
            { field: 'assessment_template_id', headerName: 'Type', width: 90, align:'center',headerAlign:'center'},
            { field: 'assessment_type_id', headerName: 'By', align: 'center', headerAlign:'center', width: 80, sortable:false},
            { field: 'deadline_date', headerName: 'Deadline', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125},
            { field: 'rom_name', headerName: 'Manager Name', width: 160},
        ]

        this.datasheetFieldSpecs2 = [
            { field: 'nominate', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.createNom(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={!this.state.search_ready}
                >
                    Nominate
                    {/* <HowToRegTwoTone/> */}
                </Button>
            )},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]
    }

    componentDidMount = (show_all = false) => {

        Gserv.sendCommand('query_my_nominations',this.props.gwt,{
            show_all: show_all
        })
        .then(reply=>{
            // console.log('query_my_nominations reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_my_nominations) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_my_nominations) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    for (var i=0;i<record_array.length;i++){
                        deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                        record_array[i].deadline_date = deadline_date;
                    }
                }

                if (this.state.filter_applied){
                    this.setState({querying:false, nominations_array:reply.Records?reply.Records : []});
                    if (!reply.Records) {this.setState({filtered_nominations_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, nominations_array:reply.Records?reply.Records : [], filtered_nominations_array:reply.Records?reply.Records : []});
                }

            }
        });

    };
    
    createNom = (parms) => {
        // console.log('parms :>> ', parms);
        this.setState({creating_nomination:true, search_ready:false});
        Gserv.sendCommand('create_nomination',this.props.gwt,{
            assessment: this.state.current_record,
            nominee: parms.row
        })
        .then(reply => {
            // console.log('createNom reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (create_nomination) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_nomination) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else {
                this.setState(this.initial_state);
                this.componentDidMount(this.state.show_all);
            }
        });

    }

    openSearch = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,nominate_view:true});
    }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number){return}

        this.setState({searching:true, search_ready:false});
        Gserv.sendCommand('find_users',this.props.gwt,{
            search_string: this.state.search_name? this.state.search_name : this.state.search_number,
            search_type: this.state.search_name? 'surname' : 'employee number',
            assessment: this.state.current_record
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error:true,error_message:"No employee records found matching the search."});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({nominees_array:reply.Records,show_nominees:true,searching:false,search_ready:true});

            }
        });

    }

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'show_all':
                this.setState({show_all:e.value});
                this.componentDidMount(e.value);
                break;

            default:
                break;
        }
    }

    resetMe = () => {
        this.setState({search_name:'', search_number: '',searching:false,error:false,error_message:'',search_ready:false,show_nominees:false});
        this.componentDidMount(this.state.show_all);
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_nominations_array : this.state.nominations_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.nominations_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.nominations_array){
                        if (record.assessee_name.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.nominations_array){
                        if (record.assessee_employee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.nominations_array){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_nominations_array: temp_array, filter_applied:true});
        }
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_nominations_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_nominations_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Pending Nominations ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Nominations Required as at ' + dateStr + '.xlsx');
        }
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                // justifyContent='flex-start'
                // alignContent='flex-start'
                // style={{backgroundColor:'yellow'}}
            >
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1155
                    }}
                >
                    <Grid
                        container
                        justifyContent='center'
                        alignItems='center'
                        // style={{backgroundColor:'green'}}
                    >
                        <Grid item xs={4}>
                            <div style={{display:'flex', justifyContent: 'space-evenly', alignItems:"center"}}>
                               
                                {this.props.super_admin&&
                                <Toggle
                                    fieldMap={{field: "show_all", headerName: "Show All?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                    setField={this.handleToggleChange}
                                />}

                                <Tooltip title="Export to Excel">
                                <span>
                                <IconButton 
                                    aria-label='Export to Excel'
                                    onClick={this.exportMe}
                                    disabled={this.state.filtered_nominations_array.length===0}
                                >
                                    <ExcelLogo />
                                </IconButton>
                                </span>
                                </Tooltip>
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography style={{padding:'15px'}}>
                                Required Nominations
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Grid 
                                container
                                alignItems='center'
                                justifyContent='space-evenly'
                                // style={{backgroundColor:'yellow'}}
                            >
                                <FilterBox
                                    setParentFilter={this.handleFilterChange}
                                    data_populated={this.state.nominations_array.length>0? true : false}
                                    filter_applied={this.state.filter_applied}
                                    filter_obj={this.state.filter_obj}
                                    show_hod_filter={this.props.super_admin}
                                    // show_branch_filter={true}
                                    // show_cycle_filter={true}
                                />
                            </Grid>
                        </Grid>
                        
                    </Grid>


                    {!this.state.nominate_view&&
                    <DatasheetView 
                        dataset={this.state.filtered_nominations_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete'}
                        height={500}
                    />}

                    {this.state.nominate_view&&
                    <div>    
                    <hr/>    
                    <Typography
                        color='primary'
                        style={{paddingTop:10}}
                    >
                        Please nominate a <b>{this.state.current_record.assessment_type.toLowerCase()}</b> of {this.state.current_record.assessee_name} to make the following assessment:
                    </Typography>
                    <Typography>
                        {this.state.current_record.assessment_template} for cycle {this.state.current_record.cycle_code}
                    </Typography>

                    <Grid
                        container
                        direction='column'
                        justifyContent='space-evenly'
                        alignContent='center'
                        style={{padding:15}}
                    >

                        <form onSubmit={this.runSearch}>
                            <TextField
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="on"
                                autoFocus={true}
                                label={'Surname Search'}
                                variant='outlined'
                                value={this.state.search_name}
                                onChange={(e) => {
                                    const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                    const can_sub = (outText.length>2);
                                    this.setState({search_name: outText, search_number: '', search_ready: can_sub, error: false});
                                }}
                                // required
                                style={{marginBottom:'10px', marginRight:'10px'}}
                                disabled={this.state.searching}
                            />

                            <TextField
                                autoComplete="off"
                                autoCorrect="off"
                                autoCapitalize="off"
                                autoFocus={false}
                                label={'Employee # Search'}
                                variant='outlined'
                                value={this.state.search_number}
                                onChange={(e) => {
                                    const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                    const can_sub = (outText.length>2);
                                    this.setState({search_number: outText, search_name:"", search_ready: can_sub, error: false});
                                }}
                                // required
                                style={{marginBottom:'10px', marginLeft:'10px'}}
                                disabled={this.state.searching}
                            />

                            <br/>
                            <Button
                                variant='contained'
                                color='primary'
                                type='submit'
                                disabled={!this.state.search_ready}
                            >
                                Search
                            </Button>
                            <Button
                                variant='contained'
                                onClick={()=>this.setState({nominate_view:false,search_name:'',search_ready:false,searching:false,current_record:{},error:false,error_message:'',show_nominees:false})}
                                style={{marginLeft:'10px'}}
                                // color='primary'
                                // type='submit'
                                disabled={this.state.creating_nomination}
                            >
                                Back
                            </Button>
                        </form>
                    </Grid>
                    </div>}

                    {this.state.show_nominees&&
                    <DatasheetView 
                        dataset={this.state.nominees_array}
                        fieldspecs={this.datasheetFieldSpecs2}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.searching}
                        deleteHeaderName={'Delete'}
                        height={350}
                    />}


                </Paper>
                </Grid>

                <Grid item>
                    <Typography color='secondary' style={{Width:1155,maxWidth:1155, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

            </Grid>
        );
    }
    
}